export default __webpack_public_path__ + "static/contribution-banner-5657f0056bce6f992fe3222c2201253b.png";